import { createUseQueryHook } from 'hooks/createUseQueryHook';

export const useTrainPlacesAvailability = createUseQueryHook('get_rail_places_availability');
